/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Header, List } from "../GridComponents";
import { withRouter } from "react-router-dom";

import SingleItem from "./SingleItem";

class Grid extends Component {
	constructor(props) {
		super(props);
		this.url = props.match.url;
		this.push = props.history.push;
	}

	deleteItem = (id, name) => {
		this.props.delete(id, name);
	};

	createItem = () => {
		this.push(`${this.url}/new`);
	};

	duplicateItem = id => {
		this.push(`${this.url}/copy/${id}`);
	};

	editItem = id => {
		this.push(`${this.url}/${id}`);
	};

	render() {
		const { pluralItemName, items, select, fieldsToDisplay, defaultText } = this.props;

		return (
			<div className="table-ui">
				<Header pluralItemName={pluralItemName} createItem={this.createItem} />
				<List
					defaultText={defaultText}
					items={items}
					renderItem={({ item }) => (
						<SingleItem
							item={item}
							deleteItem={this.deleteItem}
							duplicateItem={this.duplicateItem}
							editItem={this.editItem}
							selectItem={select}
							fieldsToDisplay={fieldsToDisplay}
						/>
					)}
				/>
			</div>
		);
	}
}

Grid.propTypes = {
	singleItemName: PropTypes.string,
	pluralItemName: PropTypes.string,
	match: PropTypes.object,
	items: PropTypes.array,
	fieldsToDisplay: PropTypes.array,
	delete: PropTypes.func,
	select: PropTypes.func,
	history: PropTypes.object,
	defaultText: PropTypes.string,
};
export default withRouter(Grid);
